<template>
  <div class="login">
    <h1 data-text="推广分销系统"></h1>
    <div class="box">
      <div class="head">微信登录</div>
      <div class="body">
        <div class="qrcode">
          <!-- <qrcode
            :value="qrcodeUrl"
            :options="{ size: 300 }"
            class="scan-code-img"
          ></qrcode> -->
          <!-- <img src="../assets/image/qrcode-loading.png" alt="二维码读取中" /> -->
          <img :src="qrcodeUrl || loadingImg" />
          <!-- <canvas></canvas> -->
          <div class="expire" v-show="!loopDurationTime">
            <div class="package">
              <div class="note">二维码已过期</div>
              <div class="button" @click="getLoginCode">刷新</div>
            </div>
          </div>
        </div>
        <div class="introduce">
          <i class="ico-scan"></i>
          <span>
            {{ loopDurationTime ? "用微信扫一扫登录" : "二维码已失效" }}</span
          >
        </div>
      </div>
      <div class="foot">「关注公众号」自动登录</div>
    </div>
    <div class="product">
      <p class="name">小财鼠</p>
      <p class="url">
        <a href="//www.xiaocaishu.com/" target="_blank">www.xiaocaishu.com</a>
      </p>
    </div>
  </div>
</template>

<script>
import { api, copyToClipboard, getParams } from "@/api";
import qrcode from "@xkeshi/vue-qrcode";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      appId: "",
      qrcodeUrl: "",
      loopDurationTime: 200,
      loginCode: "",
      countDownTimer: null,
      coutDownNum: 0,
      redirect: "",
      loadingImg: require("../assets/image/qrcode-loading.png"),
    };
  },
  components: {
    qrcode,
  },
  computed: {
    ...mapState({
      isWeixin: (state) => state.isWeixin,
      isPC: (state) => state.isPC,
    }),
  },
  methods: {
    ...mapActions(["updateUserInfo"]),
    countDown() {
      this.clearCountDown();
      this.countDownTimer = setInterval(() => {
        this.loopDurationTime--;
        if (this.loopDurationTime == 0) {
          this.clearCountDown();
        }
        this.toLoopLogin();
      }, 1000);
    },
    clearCountDown() {
      clearInterval(this.countDownTimer);
      this.countDownTimer = null;
    },
    hasLogin(options) {
      this.updateUserInfo(options);
      this.$router.replace({
        path: "/",
        query: {
          appId: this.appId,
        },
      });
    },
    async getLoginCode() {
      let res = await api.getSignInQrcode({
        appId: this.appId,
      });
      if (res.data) {
        let code = res.data.cache_key;
        this.loginCode = code;
        this.qrcodeUrl = res.data.url;
        this.loopDurationTime = 200;
        this.countDown();
      }
    },
    async toLoopLogin() {
      let res = await api.getSignInStatus({
        cache_key: this.loginCode,
      });
      if (res.token) {
        let token = res.token;
        if (token) {
          //登录成功
          localStorage.setItem("_token", token);
          this.clearCountDown();
          this.checkLogin();
        }
      }
    },
    async checkLogin() {
      let appId = Number(getParams("appId") || 6);
      this.appId = appId;
      if (!api.checkToken() && this.isWeixin) {
        const url = await api.getLoginByweChatUr({ appId: appId });
        window.location.href = url.url;
        return;
      }
      const info = await api.getLoginInfo({ appId: appId });
      if (info.info) {
        this.hasLogin(info);
      } else {
        if (this.isWeixin) {
          const url = await api.getLoginByweChatUr({ appId: appId });
          window.location.href = url.url;
          return;
        }
        this.getLoginCode();
      }
    },
  },
  created() {
    this.checkLogin();
  },
  destroyed() {
    this.clearCountDown();
  },
};
</script>
